import tw, { styled } from 'twin.macro';

export const StyledFormFooter = styled.div<{ isCondensed?: boolean }>`
  ${tw`text-center`}
  ${tw`gap-2`}
  ${({ isCondensed }) => (isCondensed ? tw`flex flex-col items-center` : tw`grid grid-cols-1`)}
  .btn {
    ${tw`whitespace-normal`}
  }
`;
